import { t } from "i18next";
import rankingsIcon from "../../assets/images/rankings.svg";
import athletesIcon from "../../assets/images/athletes-white.svg";
import teamsIcon from "../../assets/images/teams-white.svg";

import { Link } from "react-router-dom";

export function RankingsMini() {
    return (<div className="block block-rankings-mini">
            <div className="block-inner">
                <h3 className="block-title">
                    <img src={ rankingsIcon } alt={ t("rankings")} />
                    { t("rankings") }
                </h3>
                <div className="block-content">
                    <div className="links-list">
                        <div className="link-item">
                            <Link to="/rankings/athletes" title={ t("athletes") } className="btn btn-primary">
                                <img src={ athletesIcon } alt={ t("athletes") } />
                                { t("athletes") }
                            </Link>
                        </div>
                        <div className="link-item">
                            <Link to="/rankings/teams" title={ t("teams") } className="btn btn-primary">
                                <img src={ teamsIcon } alt={ t("teams") } />
                                { t("teams") }
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
}